export default __webpack_public_path__ + "static/media/logout.10d8dcec.svg";